import { useEffect } from 'react';

import { RG_L, RG_R } from './logoPaths';

const TOTAL_MS = 2350;

// The site's opening: a metal door with the logo in relief, LEDs run the grooves,
// the door splits and opens. Played once, right after the reader signs in.
export const DoorIntro = ({ onDone }: { onDone: () => void }) => {
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const t = window.setTimeout(onDone, reduce ? 0 : TOTAL_MS);
    return () => window.clearTimeout(t);
  }, [onDone]);

  const half = (side: 'l' | 'r') => (
    <div className={`door door-${side}`}>
      <div className="door-face">
        <span className="door-groove g1" />
        <span className="door-groove g2" />
        <span className="door-plate" />
        <svg className="ib" viewBox={side === 'l' ? '6 10 42 128' : '98 10 42 128'}>
          <path d={side === 'l' ? RG_L : RG_R} />
        </svg>
        <span className="door-dot" />
        <span className="door-sheen" />
      </div>
    </div>
  );

  return (
    <div className="intro" aria-hidden="true">
      <svg width="0" height="0" style={{ position: 'absolute' }} focusable="false">
        <defs>
          <linearGradient id="mt-or" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#FFA45F" />
            <stop offset=".55" stopColor="#E6630B" />
            <stop offset="1" stopColor="#B4460A" />
          </linearGradient>
          <linearGradient id="mt-or-edge" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#FFE3CB" />
            <stop offset=".5" stopColor="#FFB27A" stopOpacity=".45" />
            <stop offset="1" stopColor="#FF9A52" stopOpacity=".2" />
          </linearGradient>
        </defs>
      </svg>
      {half('l')}
      {half('r')}
      <span className="intro-seam" />
    </div>
  );
};
